import React from "react";
import { INicu } from "../types/interfaces/INicu";
import { CardContent, Grid, Typography } from "@mui/material";

//This function creates a card for nicu other info.
export default function NicuDetailOtherInfoCard(props: {nicu: INicu}) {

    const LastUpdatedDate: string = props.nicu.LastUpdatedDate == null? "" : new Intl.DateTimeFormat('en-US').format(new Date(props.nicu.LastUpdatedDate));
    
    return (
        <React.Fragment>
            <CardContent>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                    <Grid item xs={5}>
                        <Typography variant="h6">Facility Code:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.FacilityCode}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h6">University Affiliation:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.UniversityAffiliation}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h6">Website:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{props.nicu.Website}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="h6">Last Updated:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography>{LastUpdatedDate}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </React.Fragment>
    );
}